module.exports = __webpack_public_path__ + "img/features3.a31f0dd9.png";